import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { MoneyFragmentFragmentDoc } from './moneyFragment';
import { MaterialShoreHardnessFragmentFragmentDoc } from './materialShoreHardnessFragment';
import { ToleranceFragmentFragmentDoc } from './toleranceFragment';
export type EnquiryPartFragmentFragment = { __typename?: 'OmsEnquiryPartType', applicableCertificateKeys: Array<Types.OmsEnquiryCertificateEnum>, customColor?: string | null, finishCustomColor?: string | null, processCustomColor?: string | null, customFinish?: string | null, customMaterial?: string | null, customShoreHardness?: string | null, deleted: boolean, externalRfqOfferId?: string | null, hasCleaned: boolean, id: string, isFavoriteMaterialType: boolean, name: string, position: number, priceOptions?: object | null, quantity: number, rfqFeedback?: string | null, rfqIsUrgent?: boolean | null, rfqNeedEngineer?: boolean | null, rfqNeedEngineerAt?: string | null, rfqNeedEngineerByName?: string | null, rfqNeedInfo?: boolean | null, rfqNeedInfoAt?: string | null, rfqNeedInfoByName?: string | null, rfqOfferRegion?: string | null, hasExpress?: boolean | null, rfqStatus?: string | null, rfqStatusChangedAt?: string | null, shoreHardnessId?: string | null, state: string, tagList: Array<string>, leadTimeTerms?: string | null, economyLeadDate?: string | null, standardLeadDate?: string | null, expressLeadDate?: string | null, priceExpired: boolean, priceExpiresAt?: string | null, shouldRfq: boolean, appliedCouponValueMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null, appliedPromotions?: Array<{ __typename?: 'OmsEnquiryAppliedPromotionType', id: number, amountMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null, promotion: { __typename?: 'OmsEnquiryPromotionType', code: string, discountAmount?: number | null, discountUnit?: string | null, id: number, internalComment?: string | null, name: string } }> | null, color?: { __typename?: 'Color', id: string, name: string } | null, finishColor?: { __typename?: 'Color', id: string, name: string } | null, processColor?: { __typename?: 'Color', id: string, name: string } | null, dimensions?: { __typename?: 'Dimension', x?: number | null, y?: number | null, z?: number | null } | null, files: Array<{ __typename?: 'AttachedFile', context: string, id: string, isCleaned: boolean, isStp?: boolean | null, name: string, parentId?: number | null, preview?: string | null, previewPriority: number, url?: string | null }>, finish?: { __typename?: 'Finish', id: string, name: string } | null, material?: { __typename?: 'Material', id: string, name: string, options?: object | null, shoreHardnesses: Array<{ __typename?: 'ShoreHardness', custom: boolean, default: boolean, id: number, name: string }>, tolerancesNew: Array<{ __typename?: 'Tolerance', default: boolean, i18nKey?: string | null, id: number, name: string, quantityEnabled: boolean, value: string }> } | null, priceMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null, process?: { __typename?: 'OmsEnquiryProcessType', id: number, name: string } | null, rfqOffer?: { __typename?: 'RfqOffer', id: number, provider: { __typename?: 'Provider', country?: string | null, id: number, name?: string | null } } | null, rfqOwner?: { __typename?: 'User', id: number, name: string } | null, rfqPositions: Array<{ __typename?: 'RfqPosition', id: number, rfqState: Types.RfqsStateEnumType }>, toolPriceMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null, manualPriceMoney?: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } | null, quantityOptions?: Array<{ __typename?: 'OmsEnquiryPartQuantityOptionMoney', leadTime?: number | null, quantity: number, leadDate?: string | null, priceMoney: { __typename?: 'Money', amount: string, amountCents: string, currencyCode: Types.CurrencyEnum } }> | null };

export const EnquiryPartFragmentFragmentDoc = gql`
    fragment enquiryPartFragment on OmsEnquiryPartType {
  applicableCertificateKeys
  appliedCouponValueMoney {
    ...moneyFragment
  }
  appliedPromotions {
    amountMoney {
      ...moneyFragment
    }
    id
    promotion {
      code
      discountAmount
      discountUnit
      id
      internalComment
      name
    }
  }
  color {
    id
    name
  }
  customColor
  finishColor {
    id
    name
  }
  finishCustomColor
  processColor {
    id
    name
  }
  processCustomColor
  customFinish
  customMaterial
  customShoreHardness
  deleted
  dimensions {
    x
    y
    z
  }
  externalRfqOfferId
  files {
    context
    id
    isCleaned
    isStp
    name
    parentId
    preview
    previewPriority
    url
  }
  finish {
    id
    name
  }
  hasCleaned
  id
  material {
    id
    name
    options
    shoreHardnesses {
      ...materialShoreHardnessFragment
    }
    tolerancesNew {
      ...toleranceFragment
    }
  }
  isFavoriteMaterialType
  name
  position
  priceMoney {
    ...moneyFragment
  }
  priceOptions
  process {
    id
    name
  }
  quantity
  rfqFeedback
  rfqIsUrgent
  rfqNeedEngineer
  rfqNeedEngineerAt
  rfqNeedEngineerByName
  rfqNeedInfo
  rfqNeedInfoAt
  rfqNeedInfoByName
  rfqOffer {
    id
    provider {
      country
      id
      name
    }
  }
  rfqOfferRegion
  rfqOwner {
    id
    name
  }
  rfqPositions {
    id
    rfqState
  }
  hasExpress
  rfqStatus
  rfqStatusChangedAt
  shoreHardnessId
  state
  tagList
  toolPriceMoney {
    ...moneyFragment
  }
  leadTimeTerms
  economyLeadDate
  standardLeadDate
  expressLeadDate
  manualPriceMoney {
    ...moneyFragment
  }
  priceExpired
  priceExpiresAt
  shouldRfq
  quantityOptions {
    leadTime
    quantity
    leadDate
    priceMoney {
      ...moneyFragment
    }
  }
}
    ${MoneyFragmentFragmentDoc}
${MaterialShoreHardnessFragmentFragmentDoc}
${ToleranceFragmentFragmentDoc}`;